
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 12 10"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"fill":"currentColor","d":"M11.1351.621622c.1442-.162163.2883-.162163.4325 0l.3243.297297c.1441.162161.1441.315311 0 .459461l-8.10811 8.1081c-.16216.16217-.31532.16217-.45946 0L.108108 6.27026c-.1441441-.14414-.1441441-.2973 0-.45946l.324325-.2973c.054054-.07207.126126-.1081.216216-.1081.090091 0 .162163.03603.216217.1081L3.54054 8.18918 11.1351.621622z"}})])
          )
        }
      }
    